<mat-menu #listsMenu="matMenu">
  <div [attr.dir]="textDirection">
    <ng-container
      *ngIf="
        !recordItem?.externalLink &&
        !alreadyCheckedOut() &&
        isHistoryItem &&
        !recordItem?.learningExperienceId &&
        recordItem?.availability &&
        recordItem?.availability?.availableToCheckout">
      <!-- Checkout Section -->

      <!-- <app-checkout-button
            *ngIf="
              !recordItem?.externalLink &&
              !alreadyCheckedOut() &&
              isHistoryItem &&
              !recordItem?.learningExperienceId &&
              recordItem?.availability &&
              recordItem?.availability?.availableToCheckout"
            [isMoreOption]="true"
            [recordIcon]="recordItem?.icon?.icon"
            [recordId]="recordItem?.id">
          </app-checkout-button> -->
      <button mat-menu-item appStopPropagation (click)="doCheckout()">
        <span class="odilo-icon" aria-hidden="true">{{ recordItem?.icon?.icon }}</span>
        {{ 'button.checkout' | translate }}
      </button>
    </ng-container>

    <ng-container
      *ngIf="!recordItem?.externalLink &&
      !alreadyCheckedOut() &&
      isHistoryItem &&
      !recordItem?.learningExperienceId &&
      recordItem?.availability &&
      !recordItem?.availability?.availableToCheckout">
      <!-- Hold Section -->

      <!-- <app-hold-button
            *ngIf="
              !recordItem?.externalLink &&
              !alreadyCheckedOut() &&
              isHistoryItem &&
              !recordItem?.learningExperienceId &&
              recordItem?.availability &&
              !recordItem?.availability?.availableToCheckout"
            [isMoreOption]="true"
            [issueDate]="issueDate"
            [recordIcon]="recordItem?.icon?.icon"
            [recordItem]="recordItem"
            [rssItem]="rssItem">
          </app-hold-button> -->
      <button
        mat-menu-item
        *ngIf="!recordItem?.availability?.availableCopies && !isPhysicalItem()"
        appStopPropagation
        [class.waiting]="waiting"
        (click)="hold()">
        <ng-container *ngIf="!waiting">
          <span class="odilo-icon" aria-hidden="true">{{ recordItem?.icon?.icon }}</span>
          {{ 'button.hold' | translate }}
        </ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="recordItem?.active && recordItem?.externalLink">
      <!-- External link Section -->

      <!-- <app-external-link-button
            *ngIf="recordItem?.active && recordItem?.externalLink"
            [isMoreOption]="true"
            [recordIcon]="recordItem?.icon?.icon"
            from="USER_SCREEN"
            [recordItem]="recordItem">
          </app-external-link-button> -->
      <button mat-menu-item appStopPropagation (click)="openExternalLink()">
        <span class="odilo-icon" [className]="recordItem?.icon?.className" aria-hidden="true"
          >{{ recordItem?.icon?.icon }}</span
        >
        {{ 'common.open' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="alreadyCheckedOut()">
      <!-- Download Section -->

      <!-- <app-download-button
            *ngIf="alreadyCheckedOut()"
            [recordItem]="recordItem"
            [isMoreOption]="true"
            [issueDate]="issueDate"
            [rssItem]="rssItem">
          </app-download-button> -->
      <ng-container *ngIf="formats.length; then multiple; else simple"></ng-container>

      <ng-template #multiple>
        <mat-menu #checkoutMenu="matMenu">
          <button mat-menu-item appStopPropagation (click)="download(defaultFormat)" class="default">
            {{ getActionLabel(defaultFormat) | translate }}
            <span class="odilo-icon" aria-hidden="true">check</span>
          </button>
          <button mat-menu-item *ngFor="let format of formats" appStopPropagation (click)="download(format)">
            {{ getActionLabel(format) | translate }}
          </button>
        </mat-menu>
        <button mat-menu-item class="only-icon download__item" [dir]="textDirection" [matMenuTriggerFor]="checkoutMenu">
          <span class="download__item-text">
            <span class="odilo-icon" aria-hidden="true">{{ recordItem?.icon?.icon }}</span>
            {{ buttonLabel | translate }}
          </span>
          <span class="odilo-icon arrow" aria-hidden="true">navigate_next</span>
        </button>
      </ng-template>

      <ng-template #simple>
        <button
          *ngIf="!isPhysicalItem()"
          mat-menu-item
          appStopPropagation
          (click)="download()"
          [attr.aria-label]="buttonLabel | translate">
          <span class="odilo-icon" aria-hidden="true">{{ recordItem?.icon?.icon }}</span>
          <span class="text" aria-hidden="true">{{ buttonLabel | translate }}</span>
        </button>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="isHoldItem">
      <!-- Return Section -->

      <!-- <app-return-button
        *ngIf="this.configService.get().showReturnLoanButton
        && ((alreadyCheckedOut() && isCheckoutItem) || isHoldItem)"
        [recordItem]="recordItem"
        [isMoreOption]="true"
        [issueDate]="issueDate"
        [rssItem]="rssItem"
        [isHoldItem]="isHoldItem"></app-return-button> -->
      <div
        *ngIf="checkout()"
        [opacTooltip]="'tooltip.disabledReturn' | translate"
        [opacTooltipDisabled]="checkout()?.returnable">
        <button
          class="warn transparent"
          mat-menu-item
          [class.waiting]="waiting"
          [disabled]="!checkout()?.returnable"
          appStopPropagation
          (click)="doReturn()">
          <ng-container *ngIf="!waiting">
            <opac-icon [ariaHidden]="true" class="odilo-icon" icon="loan"></opac-icon>
            <span class="text" aria-hidden="true">{{ 'button.return' | translate }}</span>
          </ng-container>

          <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="!isCareerPlan && showFavoriteButton">
      <!-- Favorite Section -->

      <!-- <app-favorite-button *ngIf="!isCareerPlan" [recordId]="recordItem?.id" [isMoreOption]="true"></app-favorite-button> -->
      <button
        *ngIf="!alreadyInFavorites"
        [id]="'favoriteButton' + recordItem?.id"
        class="only-icon"
        mat-menu-item
        (click)="addToFavorites()">
        <span class="odilo-icon" aria-hidden="true">favorite</span>
        {{ 'tooltip.addToFavorites' | translate }}
      </button>
      <button *ngIf="alreadyInFavorites" class="only-icon is-favorite" mat-menu-item (click)="removeFromFavorites()">
        <span class="odilo-icon" aria-hidden="true">favorite_black</span>{{ 'tooltip.removeFromFavorites' | translate }}
      </button>
    </ng-container>

    <ng-container>
      <!-- Share Section -->

      <button
        *ngIf="!isCareerPlan && showShareButtons"
        class="only-icon share-button__item"
        mat-menu-item
        [matMenuTriggerFor]="shareMenu">
        <span class="share-button__item-text">
          <span class="odilo-icon" aria-hidden="true">share</span> {{ 'common.share' | translate }}
        </span>
        <span class="odilo-icon arrow" aria-hidden="true">navigate_next</span>
      </button>
      <mat-menu #shareMenu>
        <app-share-menu
          [include]="socialButtons"
          [description]="shareText"
          [title]="recordItem.title"
          [url]="getSharingUrl(recordItem.id)"></app-share-menu>
      </mat-menu>
    </ng-container>

    <button *ngIf="showShareCertificateButton" mat-menu-item (click)="shareCertificateOnLinkedin()">
      <span class="odilo-icon" aria-hidden="true">link</span> {{'button.share.certificate.linkedin' | translate }}
    </button>

    <ng-container>
      <!-- Add to list Section -->

      <!-- <app-add-to-list-button
        *ngIf="!isCareerPlan"
        [recordId]="recordItem?.id"
        [isMoreOption]="true"></app-add-to-list-button> -->
      <mat-menu #listsMenu2="matMenu">
        <button mat-menu-item (click)="openNewListDialog()">
          <mat-icon>add</mat-icon> {{ 'button.newList' | translate }}
        </button>
        <mat-divider *ngIf="userService.lists.length"></mat-divider>
        <button
          class="list-container"
          mat-menu-item
          *ngFor="let list of userService.lists"
          (click)="addToList(list.id)">
          <span class="list-container__list-name" ellipsis> {{list.name}} </span>
          <span *ngIf="isRecordInList(list.id)" class="odilo-icon check" aria-hidden="true">check</span>
        </button>
      </mat-menu>

      <button mat-menu-item class="only-icon add-to-list__item" [dir]="textDirection" [matMenuTriggerFor]="listsMenu2">
        <span class="add-to-list__item-text">
          <span class="odilo-icon" aria-hidden="true">list_notebook</span>
          {{ 'tooltip.addToList.label' | translate }}
        </span>
        <span class="odilo-icon arrow" aria-hidden="true">navigate_next</span>
      </button>
    </ng-container>

    <ng-container *ngIf="isHistoryItem">
      <!-- History statistics Section -->
      <button mat-menu-item (click)="openHistoryStatistics()">
        <span class="odilo-icon" aria-hidden="true"> statistics </span>{{ 'history.stats.title' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="pageName">
      <!-- Internal page Section -->

      <!-- <internal-page-button
        *ngIf="pageName"
        [isMoreOption]="true"
        [pageName]="pageName"
        [extras]="extras"></internal-page-button> -->
      <button mat-menu-item (click)="navigatePage()">
        <span class="odilo-icon" aria-hidden="true"> format_education </span>{{ 'common.open' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="isHistoryItem || isCareerPlan">
      <!-- Certificate Section -->

      <!-- <app-certificate-button
        *ngIf="isHistoryItem || isCareerPlan"
        [isMoreOption]="true"
        [historyItem]="historyItem"
        [certificateUrl]="certificateUrl"></app-certificate-button> -->
      <ng-container *ngIf="historyItem">
        <button
          mat-menu-item
          *ngIf="historyItem.record.learningExperienceId && historyItem.urlCertificate"
          (click)="openCertificate(historyItem.urlCertificate)">
          <span class="odilo-icon" aria-hidden="true">download</span>
          {{ 'button.download.certificate' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="certificateUrl">
        <button mat-menu-item *ngIf="certificateUrl" (click)="openCertificate(certificateUrl)">
          <span class="odilo-icon" aria-hidden="true">download</span>
          {{ 'button.download.certificate' | translate }}
        </button>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="this.configService.get().showReturnLoanButton
    && ((alreadyCheckedOut() && isCheckoutItem))">
      <!-- Return Section -->

      <!-- <app-return-button
        *ngIf="this.configService.get().showReturnLoanButton
        && ((alreadyCheckedOut() && isCheckoutItem) || isHoldItem)"
        [recordItem]="recordItem"
        [isMoreOption]="true"
        [issueDate]="issueDate"
        [rssItem]="rssItem"
        [isHoldItem]="isHoldItem"></app-return-button> -->
      <div
        *ngIf="checkout() && !isPhysicalItem()"
        [opacTooltip]="'tooltip.disabledReturn' | translate"
        [tooltipDisabled]="checkout()?.returnable">
        <button
          class="warn transparent"
          mat-menu-item
          [class.waiting]="waiting"
          [disabled]="!checkout()?.returnable"
          appStopPropagation
          (click)="showReturnCheckoutDialog.set(true)">
          <ng-container *ngIf="!waiting">
            <span class="odilo-icon" aria-hidden="true">delete</span>
            <span class="text" aria-hidden="true">{{ 'button.return' | translate }}</span>
          </ng-container>

          <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="isHoldItem">
      <button *ngIf="record.citable" class="only-icon" mat-menu-item (click)="openCitationDialog()">
        <opac-icon [ariaHidden]="true" slot="start" class="odilo-icon" icon="quotes"></opac-icon>
        <span>{{ 'tooltip.cite' | translate }}</span>
      </button>

      <button class="only-icon" mat-menu-item (click)="openReportDialog()">
        <opac-icon [ariaHidden]="true" slot="start" class="odilo-icon" icon="report_problem"></opac-icon>
        <span>{{ 'report.title' | translate }}</span>
      </button>
    </ng-container>

    <button
      mat-menu-item
      class="only-icon"
      *ngIf="historyItem && historyItem.deletable"
      (click)="handleHistoryItemToDelete(historyItem)">
      <opac-icon slot="start" class="odilo-icon" icon="delete"></opac-icon>
      {{ 'common.delete' | translate }}
    </button>

    <ng-container *ngIf="showCiteButton">
      <button *ngIf="record.citable" class="only-icon" mat-menu-item (click)="citeRecord()">
        <span class="odilo-icon" aria-hidden="true">quotes</span>
        {{ 'tooltip.cite' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="showReportButton">
      <button class="only-icon" mat-menu-item (click)="openReportDialog()">
        <span class="odilo-icon" aria-hidden="true">report_problem</span>
        {{ 'report.title' | translate }}
      </button>
    </ng-container>
  </div>
</mat-menu>
<button
  id="moreOPtion"
  mat-flat-button
  class="only-icon"
  [dir]="textDirection"
  appStopPropagation
  [opacTooltip]="'common.viewMore' | translate"
  [matMenuTriggerFor]="listsMenu"
  (menuOpened)="doBlur()">
  <span class="odilo-icon" aria-hidden="true">more_vertical</span>
</button>

<opac-recaptcha-dialog (resolved)="resolvedCaptcha($event)"></opac-recaptcha-dialog>
<opac-confirmation-dialog
  appStopPropagation
  [acceptLabel]="'common.delete'"
  [open]="showDeleteHistoryItemDialog()"
  [title]="'general.delete.element' | translate"
  (accept)="deleteHistoryItem()"
  (cancel)="showDeleteHistoryItemDialog.set(false)">
  <p>{{'button.delete.file' | translate }}</p>
</opac-confirmation-dialog>
<opac-confirmation-dialog
  appStopPropagation
  [acceptLabel]="'general.return.label'"
  [open]="showReturnCheckoutDialog()"
  [title]="'general.return.checkout' | translate"
  (accept)="doReturn()"
  (cancel)="showReturnCheckoutDialog.set(false)">
  <p>{{'messages.checkout.confirmRemove' | translate }}</p>
</opac-confirmation-dialog>
